import { EditorBylineReadOnly } from '@/components/EditorByline/ReadOnly'
import { EditorContentSourceReadOnly } from '@/components/EditorContentSource/ReadOnly'
import type { PillLink } from '@/components/EditorPill'
import { MetaBarRow } from './MetaBarRow'
import { isArticleType } from '@/lib/isArticleType'
import type { JSX } from 'react'

/**
 * The editor surface fields for documents with no Yjs document to read from,
 * the frozen snapshot rendered by PlainEditor. Same row, same gate, plain props
 * instead of `useYValue`.
 */
export const EditorMetaBarReadOnly = ({
  documentType,
  authors,
  bylineCredit,
  contentSources
}: {
  documentType: string | undefined
  authors: PillLink[] | undefined
  bylineCredit?: Array<{ value?: string }>
  contentSources: PillLink[] | undefined
}): JSX.Element | null => {
  if (!isArticleType(documentType)) {
    return null
  }

  return (
    <MetaBarRow>
      <EditorBylineReadOnly authors={authors} credit={bylineCredit} />
      <EditorContentSourceReadOnly sources={contentSources} />
    </MetaBarRow>
  )
}
